<template>
    <div v-if="model.modelReady">
        <fieldset :disabled="mode == 'readonly'  && !isTuan">
            <h2>预订限制设置</h2>
            <content-block isRequired title="提前购买时间">
                <div>
                    <label for="aheadHoursType1"><input id="aheadHoursType1" type="radio" v-model="model.aheadHoursType" :value="1"> 用户任意时间购买均可使用</label>
                </div>
                <div>
                    <label for="aheadHoursType2"><input id="aheadHoursType2" type="radio" v-model="model.aheadHoursType" :value="2">用户需提前</label>
                    <v-select class="nano-select inline-input" :disabled="model.aheadHoursType != 2" v-model="model.aheadHours" placeholder="请选择">
                        <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadHoursType2">小时</label>
                    <v-select class="nano-select inline-input" :disabled="model.aheadHoursType != 2" v-model="model.minutes" placeholder="请选择">
                        <v-option v-for="n in 60" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadHoursType2">
                        分钟购买，方可使用
                    </label>
                    <span v-if="model.aheadHoursType === 2"> <span class="orange-warning">若选择用户可随时购买使用，订单量可增加15%</span></span>
                </div>
                <div>
                    <label for="aheadHoursType3"><input id="aheadHoursType3" type="radio" v-model="model.aheadHoursType" :value="3"> 用户需在游玩</label>
                    <v-select class="mini-select inline-input" :disabled="model.aheadHoursType != 3" v-model="model.aheadDays" placeholder="请选择">
                        <v-option v-for="n in 8" :label="n-1==0?'当天':'前'+(n-1)+'天'" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadHoursType3">的</label>
                    <v-select class="nano-select inline-input" :disabled="model.aheadHoursType != 3" v-model="model.hours" placeholder="请选择">
                        <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadHoursType3">点</label>
                    <v-select class="nano-select inline-input" :disabled="model.aheadHoursType != 3" v-model="model.minutes" placeholder="请选择">
                        <v-option v-for="n in 60" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadHoursType2">
                        分前购买，方可使用
                    </label>
                    <span v-if="model.aheadHoursType === 3"> <span class="orange-warning">若选择用户可随时购买使用，订单量可增加约30%</span></span>
                </div>
                <div v-if="model.aheadHoursType === 3 && extra.isDirectDeal" v-bind:style="{color: model.needAheadSupplement?'inherit':'#999'}">
                    <label for="aheadSupplement"><input id="aheadSupplement" type="checkbox" v-model="model.needAheadSupplement"> 补充规则：用户购买后需等待</label>
                    <v-select class="nano-select inline-input" :disabled="!model.needAheadSupplement" v-model="model.aheadHoursBeforeUse" placeholder="请选择">
                        <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadSupplement">小时</label>
                    <v-select class="nano-select inline-input" :disabled="!model.needAheadSupplement" v-model="model.aheadMinutesBeforeUse" placeholder="请选择">
                        <v-option v-for="n in 60" :label="n-1" :value="n-1" :key="n">
                        </v-option>
                    </v-select>
                    <label for="aheadSupplement">
                        分钟方可使用
                    </label>
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'">
            <content-block isRequired title="联系人信息">
                <div>
                    <label for="contractInfoType1"><input id="contractInfoType1" @change="checkContractInfoRule" type="radio" v-model="model.contractInfoType" :value="1"> 不需要</label>
                    <label for="contractInfoType2"><input id="contractInfoType2" @change="checkContractInfoRule" type="radio" v-model="model.contractInfoType" :value="2"> 需要</label>
                </div>
                <div class="extra-content-block" v-if="model.contractInfoType === 2" :class="{ 'error-block-local': validateErrors.has('tab2','contractInfoRule') }" >
                    <div class="orange-warning">若不需要联系人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高</div>
                    <div>
                        <label for="CTMobile"><input id="CTMobile" @change="checkContractInfoRule" type="checkbox" v-model="model.contractInfoRule.mobile"> 手机号</label>
                        <label for="CTName"><input id="CTName" @change="checkContractInfoRule" type="checkbox" v-model="model.contractInfoRule.name"> 姓名</label>
                    </div>
                    <div class="notice" :class="{'error-text-local': validateErrors.has('tab2','contractInfoRule') }" v-show="validateErrors.has('tab2','contractInfoRule')">
                        （至少选择一项）
                    </div>
                </div>
            </content-block>
            <content-block isRequired title="游玩人信息">
                <div>
                    <label for="visitorInfoType1"><input @change="checkVisitorInfoRule" id="visitorInfoType1" type="radio" v-model="model.visitorInfoType" :value="1"> 不需要</label>
                    <label for="visitorInfoType2"><input @change="checkVisitorInfoRule" id="visitorInfoType2" type="radio" v-model="model.visitorInfoType" :value="2"> 只需要1位游玩人信息</label>
                    <label for="visitorInfoType3"><input @change="checkVisitorInfoRule" id="visitorInfoType3" type="radio" v-model="model.visitorInfoType" :value="3"> 需要全部游玩人信息</label>
                    <label for="visitorInfoType4"><input @change="checkVisitorInfoRule" id="visitorInfoType4" type="radio" v-model="model.visitorInfoType" :value="4"> 每<div class="nano-select inline-input" style="vertical-align: bottom;"><custom-input-number :min="2" :disabled="model.visitorInfoType != 4" v-model="model.visitorInfoGroupSize" ></custom-input-number></div>位游玩人共用1个信息</label>
                </div>
                <div class="extra-content-block" v-if="model.visitorInfoType !== 1" :class="{ 'error-block-local': validateErrors.has('tab2','visitorInfoRule') }">
                    <div v-if="model.visitorInfoType === 2" class="orange-warning">若不需要游玩人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高</div>
                    <div v-if="model.visitorInfoType === 3" class="orange-warning">若不需要游玩人信息，订单量可增加约30%，用户填写的信息越少，下单转化越高</div>
                    <div v-if="model.visitorInfoType === 4" class="orange-warning">若不需要游玩人信息，订单量可增加约35%，用户填写的信息越少，下单转化越高</div>
                    <div class="row">
                        <div class="col-sm-2">身份信息</div>
                        <div class="col-sm-9">
                            <div>
                                <label for="VIRName"><input id="VIRName" type="checkbox" @change="checkVisitorInfoRule" v-model="model.visitorInfoRule.name"> 姓名</label>
                                <label for="VIRMobile"><input id="VIRMobile" type="checkbox" @change="checkVisitorInfoRule" v-model="model.visitorInfoRule.mobile"> 手机号</label>
                            </div>
                            <div class="notice" :class="{'error-text-local': validateErrors.has('tab2','visitorInfoRule') }" v-show="validateErrors.has('tab2','visitorInfoRule')">
                                （至少选择一项）
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">证件信息</div>
                        <div class="col-sm-9">
                            <div>
                                <label for="VIRredentials"><input id="VIRredentials" type="checkbox" v-model="model.visitorInfoRule.credentials"> 身份证</label>
                                <label for="VIRPassport"><input id="VIRPassport" type="checkbox" v-model="model.visitorInfoRule.passport"> 护照</label>
                                <label for="VIRMtp"><input id="VIRMtp" type="checkbox" v-model="model.visitorInfoRule.mtp"> 台胞证</label>
                                <label for="VIRHkmlp"><input id="VIRHkmlp" type="checkbox" v-model="model.visitorInfoRule.hkmlp"> 港澳通行证</label>
                                <label for="VIRTlp"><input id="VIRTlp" type="checkbox" v-model="model.visitorInfoRule.tlp"> 大陆居民往来台湾通行证</label>
                            </div>
                            <div class="notice">
                                （若勾选多个证件，用户在购买时只需任选一个证件填写）
                            </div>
                        </div>
                    </div>
                </div>
            </content-block>
            <content-block isRequired title="需要线下预约" v-if="model.sourceType === 3 && model.scrAttrs">
                <div>
                    <label for="needBookOffline1"><input id="needBookOffline1" type="radio" v-model="model.scrAttrs.needBookOffline" :value="false"> 不需要</label>
                    <label for="needBookOffline2"><input id="needBookOffline2" type="radio" v-model="model.scrAttrs.needBookOffline" :value="true"> 需要</label>
                </div>
                <div class="extra-content-block" v-if="model.scrAttrs.needBookOffline">
                    <div class="extra-info-input">
                        <label for="bookTypes1"><input id="bookTypes1" type="checkbox" v-model="model.scrAttrs.offlineBookRule.bookTypes" :value="1"> 需要短信预约
                            ，请至少提前<v-input class="mini-select inline-input" v-model="model.scrAttrs.offlineBookRule.smsAheadTime"></v-input>将出行人<v-input v-model="model.scrAttrs.offlineBookRule.smsUserInfo" class="mini-select inline-input"></v-input>发送至<v-input v-model="model.scrAttrs.offlineBookRule.smsPhone" class="middle-select inline-input"></v-input></label>
                    </div>
                    <div class="extra-info-input">
                        <label for="bookTypes2"><input id="bookTypes2" type="checkbox" v-model="model.scrAttrs.offlineBookRule.bookTypes" :value="2"> 需要电话预约
                            ，请至少提前<v-input class="mini-select inline-input" v-model="model.scrAttrs.offlineBookRule.telAheadTime"></v-input>拨打<v-input class="middle-select inline-input" v-model="model.scrAttrs.offlineBookRule.telPhone"></v-input>进行预约</label>
                    </div>
                    <div class="extra-info-input">
                        <label for="bookTypes3"><input id="bookTypes3" type="checkbox" v-model="model.scrAttrs.offlineBookRule.bookTypes" :value="4"> 其他
                            <v-input class="large-select inline-input" v-model="model.scrAttrs.offlineBookRule.other"></v-input></label>
                    </div>
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'  && !isTuan">
            <content-block isRequired title="预订数量限制">
                <span>每笔订单最少购买</span>
                <div class="nano-select inline-input" style="vertical-align: bottom;">
                    <custom-input-number :min="1" v-model="model.minBuyCount" ></custom-input-number>
                </div>
                <span>张，最多购买</span>
                <div class="nano-select inline-input">
                    <v-input type="number" @blur="integerHandle" v-va.tab2="'integer'" v-model="model.maxBuyCount" placeholder="不限" :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.maxBuyCount')}" />
                </div>
                <span>张</span>
                <span v-show="validateErrors.has('tab2', 'model.maxBuyCount')" class="help is-danger">最多预订数量需为正整数，不填为不限</span>
            </content-block>
            <content-block title="手机号限制" v-if="(model.contractInfoType === 2 && model.contractInfoRule.mobile) || (model.visitorInfoRule.mobile && model.visitorInfoType != 1)">
                <span>同一手机号在</span>
                <div class="nano-select inline-input" style="vertical-align: bottom;">
                    <custom-input-number :disabled="isTuan" :min="1" v-model="model.phoneLimitDays" ></custom-input-number>
                </div>
                <span>天内最多购买</span>
                <div class="nano-select inline-input">
                    <v-input type="number" @blur="integerHandle"
                             @change="limitCheck"
                             v-va.tab2="'integer'" v-model="model.phoneLimitCount" placeholder="不限" :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.phoneLimitCount')}"/>
                </div>
                <v-select class="nano-select inline-input" :disabled="isTuan" v-model="model.phoneLimitUnitType" placeholder="请选择">
                    <v-option v-for="(item, index) in buyCountLimitTypes" :label="item.label" :value="item.value">
                    </v-option>
                </v-select>
                <span v-show="validateErrors.has('tab2', 'model.phoneLimitCount')" class="help is-danger">请输入正确的张数</span>
            </content-block>
            <content-block title="身份证限制" v-if="model.visitorInfoType !== 1 && model.visitorInfoRule.credentials">
                <span>同一身份证在</span>
                <div class="nano-select inline-input" style="vertical-align: bottom;">
                    <custom-input-number :disabled="isTuan" :min="1" v-model="model.idLimitDays" ></custom-input-number>
                </div>
                <span>天内最多购买</span>
                <div class="nano-select inline-input">
                    <v-input type="number" @blur="integerHandle"
                             @change="limitCheck"
                             v-va.tab2="'integer'" v-model="model.idLimitCount" placeholder="不限" :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.idLimitCount')}"/>
                </div>
                <v-select :disabled="isTuan" class="nano-select inline-input" v-model="model.idLimitUnitType" placeholder="请选择">
                    <v-option v-for="(item, index) in buyCountLimitTypes" :label="item.label" :value="item.value">
                    </v-option>
                </v-select>
                <span v-show="validateErrors.has('tab2', 'model.idLimitCount')" class="help is-danger">请输入正确的张数</span>
            </content-block>
            <content-block isRequired title="限购方式" v-if="buyLimitShow">
                <label><input type="radio" v-model="model.limitDayType" :value="0"> 下单日限购</label>
                <label><input type="radio" v-model="model.limitDayType" :value="1"> 游玩日限购</label>
                <span class="orange-warning">有效期模式的产品不能选择游玩日限购</span>
            </content-block>
            <content-block isRequired title="订单取消时间">
                <span>下单成功后</span>
                <v-select class="mini-select inline-input" v-model="model.orderCancelTime" placeholder="请选择">
                    <v-option v-for="n in CANCEL_MINUTE" :label="n" :value="n" :key="n">
                    </v-option>
                </v-select>
                <span>分钟内如未付款，系统将自动取消订单</span>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'">
            <h2>入园方式</h2>
            <content-block isRequired title="出票方式">
                <label v-if="!extra.isDirectDeal" for="GTM1"><input id="GTM1" :disabled="onlineBefore" type="radio" @change="changeGenerateTicketMethod" v-model="model.generateTicketMethod" :value="1"> 美团出票</label>
                <label v-if="!extra.isDirectDeal" for="GTM2"><input id="GTM2" :disabled="onlineBefore" type="radio" @change="changeGenerateTicketMethod" v-model="model.generateTicketMethod" :value="2"> 商家手工出票</label>
                <label v-if="extra.isDirectDeal" for="GTM3"><input id="GTM3" :disabled="onlineBefore" type="radio" v-model="model.generateTicketMethod" :value="3"> 商家对接出票</label>
                <div class="block-waring" v-if="model.generateTicketMethod == 2 && extra.isBD">
                    此流程是新方案，未解决需换票的二次预约的产品，请确保已经过培训并培训商家后再选择此项。直签BD咨询刘策（liuce），三方BD咨询刘策（liuce），<a href="https://wiki.sankuai.com/pages/viewpage.action?pageId=569306927">使用说明</a>
                </div>
                <div class="block-waring" v-if="model.generateTicketMethod == 2 && !extra.isBD">
                    此流程是新方案，为解决需换票的二次预约产品，请确保您已经过培训，点击下载<a href="https://awp-assets.meituan.net/HFE/hotel-fe-notp/assets/files/%E3%80%90%E8%BF%90%E8%90%A5%E6%96%87%E6%A1%A3%E3%80%91%E6%89%8B%E5%B7%A5%E5%87%BA%E7%A5%A8%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%EF%BC%88%E5%95%86%E5%AE%B6%E7%89%88%EF%BC%89V1-20170823.docx">使用说明</a>
                </div>
            </content-block>
            <content-block isRequired title="出票时间" v-if="model.generateTicketMethod == 2">
                从
                <v-select class="nano-select inline-input" v-model="model.generateTicketWorkTime.startWorkHour" placeholder="请选择">
                    <v-option v-for="n in 10" :label="n-1" :value="n-1" :key="n">
                    </v-option>
                </v-select>
                点
                <v-select class="nano-select inline-input" v-model="model.generateTicketWorkTime.startWorkMinute" placeholder="请选择">
                    <v-option v-for="n in 4" :label="(n-1)*15" :value="(n-1)*15" :key="n">
                    </v-option>
                </v-select>
                分到
                <v-select class="nano-select inline-input" v-model="model.generateTicketWorkTime.endWorkHour" placeholder="请选择">
                    <v-option v-for="n in 6" :label="n+17" :value="n+17" :key="n">
                    </v-option>
                </v-select>
                点
                <v-select class="nano-select inline-input" v-model="model.generateTicketWorkTime.endWorkMinute" placeholder="请选择">
                    <v-option v-for="n in 4" :label="(n-1)*15" :value="(n-1)*15" :key="n">
                    </v-option>
                </v-select>
                分产生的订单，<span class="red-span">30分钟</span>内出票，其他时间的订单，次日
                <span class="red-span">
                    {{model.generateTicketWorkTime.startWorkMinute + 30 >= 60? `${model.generateTicketWorkTime.startWorkHour+1}点${model.generateTicketWorkTime.startWorkMinute-30}分`:`${model.generateTicketWorkTime.startWorkHour}点${model.generateTicketWorkTime.startWorkMinute+30}分`}}
                    </span>出票
            </content-block>
            <content-block isRequired title="下单时是否回传凭证" v-if="model.generateTicketMethod == 3">
                <label for="RV1"><input id="RV1" type="radio" v-model="model.returnVoucher" :value="true"> 是</label>
                <label for="RV2"><input id="RV2" type="radio" v-model="model.returnVoucher" :value="false"> 否</label>
            </content-block>
            <content-block isRequired title="用户获取凭证方式说明" v-if="model.generateTicketMethod == 3 && !model.returnVoucher">
                <div>
                    <v-input v-va.tab2="'required'"
                             type="text"
                             :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.voucherText') }"
                             v-model="model.voucherText"
                             :maxlength="50"
                             name="voucherText"
                             placeholder="建议填写内容：“凭商家短信入园”、“凭商家二维码验证”"/>
                    <p class="help-block input-counter">{{model.voucherText.length}}/50字</p>
                    <span v-show="validateErrors.has('tab2', 'model.voucherText')" class="help is-danger">请填写用户获取凭证方式说明</span>
                </div>
                <div>
                    <span class="icon-error help-icon"></span> 此处内容用于在订单详情页告知用户凭证信息，请根据商家实际情况谨慎填写
                </div>
            </content-block>
        </fieldset>
        <fieldset :disabled="mode == 'readonly && !isTuan'">
            <content-block isRequired title="入园方式">
                <fieldset :disabled="mode == 'readonly'">
                <label for="needTicket1"><input id="needTicket1" type="radio" @change="needTicketChanged" v-model="model.needTicket" :value="false"> 无需换票，直接验证入园</label>
                <label for="needTicket2"><input id="needTicket2" type="radio" @change="needTicketChanged" v-model="model.needTicket" :value="true"> 换票入园</label><span v-if="model.needTicket" class="orange-warning">若选“无需换票，直接验证入园”模式，订单量可增加约20%</span>
                </fieldset>
                <div class="extra-content-block" v-if="model.needTicket">
                    <content-block isRequired title="换票凭证">
                        <div v-if="model.generateTicketMethod == 3">
                            <label for="GTR1"><input id="GTR1" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="4"> 商家电子码</label>
                            <label for="GTR2"><input id="GTR2" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="2"> 商家短信</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="5"> 二维码</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="6"> 身份证</label>
                            <label for="GTR5"><input id="GTR5" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="7"> 商家订单号</label>
                            <label for="GTR6"><input id="GTR6" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="3"> 商家邮件</label>
                            <label for="GTR7"><input id="GTR7" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="8"> 手机号</label>
                            <label for="GTR8"><input id="GTR8" type="checkbox" v-model="model.getTicketRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div v-if="model.generateTicketMethod == 2">
                            <label for="GTR1"><input id="GTR1" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="4"> 商家电子码</label>
                            <label for="GTR2"><input id="GTR2" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="2"> 商家短信</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="6"> 身份证原件</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" v-model="model.getTicketRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div v-if="model.generateTicketMethod == 1">
                            <label for="GTRMT"><input id="GTRMT" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="1"> 美团电子码</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getTicketRule.voucherLoaders" :value="6"> 身份证</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" v-model="model.getTicketRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div class="extra-info-input" v-if="model.getTicketRule.needCertificateSupplement">
                            <v-input v-va.tab2="'required'" v-model="model.getTicketRule.certificateSupplement" placeholder="如学生证信息" :maxlength="30" :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement') }"></v-input>
                            <p class="help-block input-counter">{{model.getTicketRule.certificateSupplement?model.getTicketRule.certificateSupplement.length:0}}/30字</p>
                        </div>
                        <span v-show="validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')" class="help float-help is-danger">补充信息不能为空</span>
                    </content-block>
                    <fieldset :disabled="mode == 'readonly'">
                    <content-block isRequired title="换票时间">
                        <div v-for="(vTime, index) in model.voucherTimes" :key="index" style="margin-bottom: 10px; position: relative">
                            <span v-if="model.voucherTimes.length > 1" style="margin-top: 4px" class="ticket-step ticket-step-active">{{index+1}}</span>
                            &nbsp;从
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherStartTimeHour" placeholder="请选择">
                                <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                                </v-option>
                            </v-select>
                            点
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherStartTimeMinute" placeholder="请选择">
                                <v-option v-for="n in SEPARATED_MINUTE" :label="(n==0)?'00':n" :value="n" :key="n">
                                </v-option>
                            </v-select>
                            分到
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherEndTimeHour" placeholder="请选择">
                                <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                                </v-option>
                            </v-select>
                            点
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherEndTimeMinute" placeholder="请选择">
                                <v-option v-for="n in SEPARATED_MINUTE" :label="(n==0)?'00':n" :value="n" :key="n">
                                </v-option>
                            </v-select>
                            <label :for="'VTNV'+index"><input :id="'VTNV'+index" type="checkbox" v-model="vTime.needVoucherOrGetInTimeSupplement"> 补充信息</label>
                            <div v-if="mode != 'readonly' && model.voucherTimes.length > 1" @click="deleteOneVoucherTime(index)" class="icon-button delete icon-cancel"></div>
                            <div v-if="mode !== 'readonly' && model.voucherTimes.length < 3 && index === model.voucherTimes.length-1" @click="addOneVoucherTime" class="icon-button icon-plus-circle"></div>
                            <div class="extra-info-input" v-if="vTime.needVoucherOrGetInTimeSupplement">
                                <v-input v-va.tab2="'required'" :class="{'input': true, 'is-danger': validateErrors.has('tab2','vTime.voucherOrGetInTimeSupplement', null, index) }" :data-key="index" v-model="vTime.voucherOrGetInTimeSupplement" placeholder="淡旺季信息，淡旺季时间等" :maxlength="30" style="margin-top: 10px"></v-input>
                                <p class="help-block input-counter">{{vTime.voucherOrGetInTimeSupplement.length}}/30字</p>
                                <span style="margin-top: -10px;" v-show="validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)" class="help is-danger">勾选后，补充信息必填</span>
                            </div>
                        </div>
                        <div v-if="model.voucherTimes.length > 1"><span class="icon-error orange-notice"></span> 设置的换票时间要覆盖该产品所有的可用日期</div>
                    </content-block>
                    <content-block isRequired title="换票地址" v-if="model.needTicket">
                        <div v-for="(item, index) in model.ticketGetAddress" :key="index" class="row extra-info-input">
                            <div class="col-sm-12">
                                <v-input v-va.tab2="'required'" :data-key="index" @change="ticketGetAddressChanged(index)" id="ticketGetAddress" :class="{'input': true, 'is-danger': validateErrors.has('tab2','model.ticketGetAddress[index]', null, index) }" placeholder="具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物" v-model="model.ticketGetAddress[index]" :maxlength="50"></v-input>
                                <p class="help-block input-counter">{{model.ticketGetAddress[index].length}}/50字</p>
                            </div>
                            <div style="margin-left: 0;" v-if="model.ticketGetAddress.length > 1" @click="deleteTicketGetAddress(index)" class="icon-button delete icon-cancel"></div>
                            <div style="padding-left: 15px;" v-show="validateErrors.has('tab2','model.ticketGetAddress[index]', null,index)" class="help float-help is-danger">换票地址不能为空</div>
                        </div>
                        <div class="icon-link-revise" v-if="mode !== 'readonly'" @click="newTicketGetAddress">
                            <span class="icon-plus-circle"></span>
                            <span class="mls"> 新增换票地址</span>
                        </div>
                    </content-block>
                    </fieldset>
                </div>
                <div class="extra-content-block" v-else>
                    <content-block isRequired title="入园凭证">
                        <div v-if="model.generateTicketMethod == 3">
                            <label for="GTR1"><input id="GTR1" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="4"> 商家电子码</label>
                            <label for="GTR2"><input id="GTR2" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="2"> 商家短信</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="5"> 二维码</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="6"> 身份证</label>
                            <label for="GTR5"><input id="GTR5" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="7"> 商家订单号</label>
                            <label for="GTR6"><input id="GTR6" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="3"> 商家邮件</label>
                            <label for="GTR7"><input id="GTR7" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="8"> 手机号</label>
                            <label for="GTR8"><input id="GTR8" type="checkbox" v-model="model.getVoucherRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div v-if="model.generateTicketMethod == 2">
                            <label for="GTR1"><input id="GTR1" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="4"> 商家电子码</label>
                            <label for="GTR2"><input id="GTR2" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="2"> 商家短信</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="6"> 身份证原件</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" v-model="model.getVoucherRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div v-if="model.generateTicketMethod == 1">
                            <label for="GTRMT"><input id="GTRMT" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="1"> 美团电子码</label>
                            <label for="GTR3"><input id="GTR3" type="checkbox" @change="voucherLoaderChanged" v-model="model.getVoucherRule.voucherLoaders" :value="6"> 身份证原件</label>
                            <label for="GTR4"><input id="GTR4" type="checkbox" v-model="model.getVoucherRule.needCertificateSupplement"> 凭证补充信息</label>
                            <span v-show="validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')" class="help is-danger">除了补充信息，至少再选一项</span>
                        </div>
                        <div class="extra-info-input" v-if="model.getVoucherRule.needCertificateSupplement">
                            <v-input v-va.tab2="'required'" v-model="model.getVoucherRule.certificateSupplement" :class="{'input': true, 'is-danger': validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement') }" placeholder="如学生证信息" :maxlength="30"></v-input>
                            <p class="help-block input-counter">{{model.getVoucherRule.certificateSupplement?model.getVoucherRule.certificateSupplement.length:0}}/30字</p>
                        </div>
                        <span v-show="validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')" class="help is-danger">补充信息不能为空</span>
                    </content-block>
                    <fieldset :disabled="mode == 'readonly'">
                    <content-block isRequired title="入园时间">
                        <div v-for="(vTime, index) in model.voucherTimes" :key="index" style="margin-bottom: 10px; position: relative">
                            <span v-if="model.voucherTimes.length > 1" style="margin-top: 4px" class="ticket-step ticket-step-active">{{index+1}}</span>
                            &nbsp;从
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherStartTimeHour" placeholder="请选择">
                                <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                                </v-option>
                            </v-select>
                            点
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherStartTimeMinute" placeholder="请选择">
                                <v-option v-for="n in SEPARATED_MINUTE" :label="(n==0)?'00':n" :value="n" :key="n">
                                </v-option>
                            </v-select>
                            分到
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherEndTimeHour" placeholder="请选择">
                                <v-option v-for="n in 24" :label="n-1" :value="n-1" :key="n">
                                </v-option>
                            </v-select>
                            点
                            <v-select class="nano-select inline-input" @change="changeTime(index)" v-model="voucherTimes[index].voucherEndTimeMinute" placeholder="请选择">
                                <v-option v-for="n in SEPARATED_MINUTE" :label="(n==0)?'00':n" :value="n" :key="n">
                                </v-option>
                            </v-select>
                            <label :for="'VTNV'+index"><input :id="'VTNV'+index" type="checkbox" v-model="vTime.needVoucherOrGetInTimeSupplement"> 补充信息</label>
                            <div v-if="model.voucherTimes.length > 1" @click="deleteOneVoucherTime(index)" class="icon-button delete icon-cancel"></div>
                            <div v-if="mode !== 'readonly' && model.voucherTimes.length < 3 && index === model.voucherTimes.length-1" @click="addOneVoucherTime" class="icon-button icon-plus-circle"></div>
                            <div class="extra-info-input" v-if="vTime.needVoucherOrGetInTimeSupplement">
                                <v-input v-va.tab2="'required'" :class="{'input': true, 'is-danger': validateErrors.has('tab2','vTime.voucherOrGetInTimeSupplement', null, index) }" :data-key="index" v-model="vTime.voucherOrGetInTimeSupplement" placeholder="淡旺季信息，淡旺季时间等" :maxlength="30" style="margin-top: 10px"></v-input>
                                <p class="help-block input-counter">{{vTime.voucherOrGetInTimeSupplement.length}}/30字</p>
                                <span style="margin-top: -10px;" v-show="validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)" class="help is-danger">勾选后，补充信息必填</span>
                            </div>
                        </div>
                        <div v-if="model.voucherTimes.length > 1"><span class="icon-error orange-notice"></span> 设置的入园时间要覆盖该产品所有的可用日期</div>
                    </content-block>
                    <content-block title="入园地址" isRequired>
                        <div v-for="(item, index) in model.getInAddresses" class="row" style="position: relative; margin-bottom: 10px" :key="index">
                            <div class="col-sm-12">
                                <v-input v-va.tab2="'required'" :data-key="index" :class="{'input': true, 'is-danger': validateErrors.has('tab2','model.getInAddresses[index]', null, index) }" placeholder="具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物" v-model="model.getInAddresses[index]" :maxlength="50"></v-input>
                                <p class="help-block input-counter">{{model.getInAddresses[index].length}}/50字</p>
                            </div>
                            <div style="margin-left: 0;" v-if="mode !== 'readonly' && model.getInAddresses.length > 1" @click="deleteGetInAddresses(index)" class="icon-button delete icon-cancel"></div>
                            <div style="padding-left: 15px;" v-show="validateErrors.has('tab2','model.getInAddresses[index]', null,index)" class="help float-help is-danger">入园地址不能为空</div>
                        </div>
                        <div class="icon-link-revise" v-if="mode !== 'readonly'" @click="newGetInAddresses">
                            <span class="icon-plus-circle"></span>
                            <span class="mls"> 新增入园地址</span>
                        </div>
                    </content-block>
                    </fieldset>
                </div>
            </content-block>
            <fieldset :disabled="mode == 'readonly'">
            <content-block title="入园地址" v-if="model.needTicket">
                <div v-for="(item, index) in model.getInAddresses" :key="index" class="row" style="position: relative; margin-bottom: 10px">
                    <div class="col-sm-11" >
                        <v-input placeholder="具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物" v-model="model.getInAddresses[index]" style="padding-right: 55px" :maxlength="80"></v-input>
                        <p class="help-block input-counter">{{model.getInAddresses[index].length}}/80字</p>
                    </div>
                    <div style="margin-left: 0;" v-if="mode !== 'readonly' && model.getInAddresses.length > 1" @click="deleteGetInAddresses(index)" class="icon-button delete icon-cancel"></div>
                </div>
                <div class="icon-link-revise" v-if="mode !== 'readonly'" @click="newGetInAddresses">
                    <span class="icon-plus-circle"></span>
                    <span class="mls"> 新增入园地址</span>
                </div>
            </content-block>
            </fieldset>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'  && !isTuan">
            <content-block title="其他说明">
                <v-input
                        v-textarea-check
                        type="textarea"
                        :rows="5"
                        class="custom-textarea"
                        :maxlength="1000"
                        v-model="model.otherNote"
                        placeholder="选填，已在其他栏填写过的信息请勿重复填写，否则产品可能被审核人员驳回">
                </v-input>
                <p class="help-block textarea-counter" :class="{'textarea-counter-red': model.otherNote.length>1000?true:false}">{{model.otherNote.length}}/1000字</p>
                <span class="help is-danger" style="display: none"></span>
            </content-block>
        </fieldset>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss">
    label {
        margin-right: 10px;
    }
    .form-item {
        margin-bottom: 23px;
        line-height: 36px;
    }
    .extra-content-block {
        border-radius: 4px;
        background-color: #fafafa;
        border: solid 1px #ccd2df;
        padding: 15px;
    }
    .orange-warning {
        font-size: 12px;
        line-height: 1.0;
        letter-spacing: 1px;
        color: #f58423;
    }
    .extra-content-block .notice {
        font-size: 12px;
        line-height: 1.0;
        letter-spacing: 1px;
        color: #666;
    }
    .extra-content-block label {
        margin-right: 20px;
        margin-bottom: 0;
    }
    .number-input {
        display: inline-block;
        width: 50px;
        margin: 0 7px;
    }
    .inline-input {
        display: inline-block !important;
        margin: 0 5px;
    }
    .nano-select {
        width: 62px;
    }
    .middle-select {
        width: 160px;
    }
    .large-select {
        width: 300px;
    }
    .mini-select {
        width: 82px;
    }
    .block-waring {
        border-radius: 2px;
        background-color: #fff7e4;
        border: solid 1px #ffe5b8;
        width: 100%;
        padding: 10px;
        line-height: 20px;
    }
    .red-span {
        color: #f00;
    }
    .orange-notice {
        color: #f58423;
        font-size: 12px;
    }
    .icon-button {
        font-size: 18px !important;
        margin-right: 10px;
        color: #06c1ae;
        display: inline-block;
        position: absolute;
        top: 8px;
    }
    .icon-button.delete {
        color: #f76120;
        margin-left: 10%;
    }
    .extra-info-input {
        margin-bottom: 10px;
        position: relative;
    }
    .icon-link-revise {
        color: #06c1ae;
        line-height: 18px;
        margin-top: 10px;
        cursor: pointer;
        [class^="icon-"], [class*=" icon-"] {
            display: inline-block;
            font-size: 18px;
            vertical-align: middle;
        }
    }
    .error-block-local {
        border-color: #F00;
    }
    .error-text-local {
        color: #F00 !important;
    }
    .float-help {
        float: left;
        margin-top: -20px;
    }
    .input-counter {
        float: right;
        position: relative;
        top: -40px;
        margin-right: 5px;
        height: 0;
    }
    .ticket-step {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #d3dce6;
        display: inline-block;
        text-align: center;
        vertical-align: top;
        font-size: 14px;
        line-height: 28px;
        color: #fff;
        padding: 0 !important;
        top: 4px;
    }

    .ticket-step-active {
        background-color: #3DC6B6;
    }
</style>

<script>
    // import { mapActions, mapGetters } from 'vuex'
    import CustomInputNumber from 'components/input-number-custom/index.vue'
    import ContentBlock from 'components/content-block/index.vue'
    import { textareaForbiddenWords, buyCountLimitTypes } from 'data/ticket'
    export default {
        components: {
            CustomInputNumber,
            ContentBlock
        },
        data () {
            return {
                PAGE: 'tab2',
                buyCountLimitTypes,
                contractInfoType: '1',
                contractInfoRule: {
                    mobile: false,
                    name: false
                },
                visitorInfoGroupSize: 1,
                visitorInfoRule: {
                    name: false,
                    mobile: false,
                    credentials: false,
                    passport: false,
                    mtp: false,
                    hkmlp: false,
                    tlp: false
                },
                aheadHoursType: '1',
                aheadHours: 0,
                hours: 0,
                minutes: 0,
                aheadDays: 0,
                minBuyCount: 1,
                maxBuyCount: '',
                phoneLimitDays: '',
                phoneLimitCount: '',
                phoneLimitUnitType: 0,
                idLimitDays: '',
                idLimitCount: '',
                idLimitUnitType: 0,
                CANCEL_MINUTE: [10, 15, 20, 30, 40, 50, 60, 90, 120],
                SEPARATED_MINUTE: [0, 15, 30, 45, 59],
                orderCancelTime: 30,
                generateTicketMethod: 2,
                voucherTimes: [{
                    voucherStartTimeHour: 8,
                    voucherStartTimeMinute: 0,
                    voucherEndTimeHour: 18,
                    voucherEndTimeMinute: 0
                }],
                ticketGetAddress: [''],
                getInAddresses: [''],
                onlineBefore: false,
                buyLimitShow: false
            }
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            extra: {
                type: Object,
                required: true
            },
            errors: {
                type: Array,
                required: true
            },
            // 编辑方式
            mode: {
                type: String,
                required: false
            },
            isTuan: {
                type: Boolean,
                default: false
            },
            readonly: Boolean
        },
        methods: {
            deleteOneVoucherTime: function (index) {
                this.model.voucherTimes.splice(index, 1)
                this.voucherTimes.splice(index, 1)
            },
            addOneVoucherTime: function () {
                if (this.model.voucherTimes.length < 3) {
                    this.model.voucherTimes.push({
                        voucherStartTime: 480,
                        voucherEndTime: 1080,
                        needVoucherOrGetInTimeSupplement: false,
                        voucherOrGetInTimeSupplement: ''
                    })
                    this.voucherTimes.push({
                        voucherStartTimeHour: 8,
                        voucherStartTimeMinute: 0,
                        voucherEndTimeHour: 18,
                        voucherEndTimeMinute: 0,
                    })
                }
            },
            newTicketGetAddress: function () {
                this.model.ticketGetAddress.push('')
                this.validateErrors.add(this.PAGE, {
                    key: this.model.ticketGetAddress.length - 1,
                    modelName: 'model.ticketGetAddress[index]',
                    showError: false,
                    rule: 'required'
                })
            },
            deleteTicketGetAddress: function (index) {
                this.model.ticketGetAddress.splice(index, 1)
                /*
                const position = this.validateErrors.search(this.PAGE, 'model.ticketGetAddress[index]', 'required', index)
                if (position >= 0) {
                    this.validateErrors.remove(this.PAGE, position)
                }
                */
            },
            newGetInAddresses: function () {
                this.model.getInAddresses.push('')
            },
            deleteGetInAddresses: function (index) {
                this.model.getInAddresses.splice(index, 1)
            },
            changeTime: function (index) {
                this.model.voucherTimes[index].voucherStartTime = (this.voucherTimes[index].voucherStartTimeHour * 60) + this.voucherTimes[index].voucherStartTimeMinute;
                this.model.voucherTimes[index].voucherEndTime = (this.voucherTimes[index].voucherEndTimeHour * 60) + this.voucherTimes[index].voucherEndTimeMinute;
            },
            changeGenerateTicketMethod() {
                if (this.model.generateTicketMethod === 1) {
                    this.model.getTicketRule.voucherLoaders = [1]
                    this.model.getVoucherRule.voucherLoaders = [1]
                } else {
                    this.model.getTicketRule.voucherLoaders = [4]
                    this.model.getVoucherRule.voucherLoaders = [4]
                }
                this.model.getTicketRule.needCertificateSupplement = false
                this.model.getVoucherRule.needCertificateSupplement = false
                this.checkVoucherLoaderErrors()
            },
            checkContractInfoRule(e) {
                const current = e.srcElement.type
                const index = this.validateErrors.search(this.PAGE, 'contractInfoRule', 'required', 0)
                if (!this.model.contractInfoRule.mobile
                    && !this.model.contractInfoRule.name
                    && this.model.contractInfoType === 2) {
                    if (index >= 0 && currnet === 'checkbox') {
                        this.validateErrors.items[this.PAGE][index].showError = true;
                    } else {
                        this.validateErrors.add(this.PAGE, {
                            key: 0,
                            modelName: 'contractInfoRule',
                            showError: current === 'radio' ? false:true,
                            rule: 'required'
                        })
                    }
                } else {
                    if (index >= 0) {
                        this.validateErrors.remove(this.PAGE, index)
                    }
                }
            },
            checkVisitorInfoRule(e) {
                const current = e.srcElement.type
                const index = this.validateErrors.search(this.PAGE, 'visitorInfoRule', 'required', 0)
                if (!this.model.visitorInfoRule.name
                    && !this.model.visitorInfoRule.mobile
                    && this.model.visitorInfoType !== 1) {
                    if (index >= 0 && current === 'checkbox') {
                        this.validateErrors.items[this.PAGE][index].showError = true;
                    } else {
                        this.validateErrors.add(this.PAGE, {
                            key: 0,
                            modelName: 'visitorInfoRule',
                            showError: current === 'radio' ? false:true,
                            rule: 'required'
                        })
                    }
                } else {
                    if (index >= 0) {
                        this.validateErrors.removeAll(this.PAGE, 'visitorInfoRule', 'required')
                    }
                }
            },
            needTicketChanged() {
                if (this.model.needTicket) {
                    if (this.model.generateTicketMethod === 1) {
                        this.model.getVoucherRule.voucherLoaders = [1]
                    } else {
                        this.model.getVoucherRule.voucherLoaders = [4]
                    }
                    for (let i = 0; i < this.model.ticketGetAddress.length; i++) {
                        const index = this.validateErrors.search(this.PAGE,'model.ticketGetAddress[index]', 'required', i)
                        if (this.model.ticketGetAddress[i].length <= 0) {
                            if (index === -1) {
                                this.validateErrors.add(this.PAGE, {
                                    key: i,
                                    modelName: 'model.ticketGetAddress[index]',
                                    showError: false,
                                    rule: 'required'
                                })
                            }
                        } else {
                            if (index >= 0) {
                                this.validateErrors.remove(this.PAGE, index)
                            }
                        }
                    }

                } else {
                    if (this.model.generateTicketMethod === 1) {
                        this.model.getTicketRule.voucherLoaders = [1]
                    } else {
                        this.model.getTicketRule.voucherLoaders = [4]
                    }
                    for (let i = 0; i < this.model.ticketGetAddress.length; i++) {
                        const index = this.validateErrors.search(this.PAGE,'model.ticketGetAddress[index]', 'required', i)
                        if (index >= 0) {
                            this.validateErrors.remove(this.PAGE, index)
                        }
                    }
                }
                this.model.ticketGetAddress = ['']
                this.model.getInAddresses = ['']
                this.validateErrors.removeAll(this.PAGE,'model.getInAddresses[index]')
                this.validateErrors.removeAll(this.PAGE,'model.ticketGetAddress[index]')
                if (this.model.needTicket) {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'model.ticketGetAddress[index]',
                        showError: false,
                        rule: 'required'
                    })
                } else {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'model.getInAddresses[index]',
                        showError: false,
                        rule: 'required'
                    })
                }
                this.model.getTicketRule.needCertificateSupplement = false
                this.model.getVoucherRule.needCertificateSupplement = false
                this.checkVoucherLoaderErrors()
            },
            ticketGetAddressChanged(index) {
                const position = this.validateErrors.search(this.PAGE,'model.ticketGetAddress[index]', 'required', index)
                if (this.model.ticketGetAddress[index].length > 0) {
                    if (position >= 0) {
                        this.validateErrors.remove(this.PAGE, position)
                    }
                } else {
                    if (position >= 0) {
                        this.validateErrors.items[this.PAGE][position].showError = true
                    } else {
                        this.validateErrors.add(this.PAGE, {
                            key: index,
                            modelName: 'model.ticketGetAddress[index]',
                            showError: true,
                            rule: 'required'
                        })
                    }
                }
            },
            voucherLoaderChanged() {
                this.checkVoucherLoaderErrors()
            },
            checkVoucherLoaderErrors: function () {
                if (this.model.needTicket) {
                    if (this.model.getTicketRule.voucherLoaders.length <= 0) {
                        this.validateErrors.add(this.PAGE, {
                            key: 0,
                            modelName: 'model.getTicketRule.voucherLoaders',
                            showError: true,
                            rule: 'required'
                        })
                    } else {
                        this.validateErrors.removeAll(this.PAGE,'model.getTicketRule.voucherLoaders')
                    }
                    this.validateErrors.removeAll(this.PAGE,'model.getVoucherRule.voucherLoaders')
                } else {
                    if (this.model.getVoucherRule.voucherLoaders.length <= 0) {
                        this.validateErrors.add(this.PAGE, {
                            key: 0,
                            modelName: 'model.getVoucherRule.voucherLoaders',
                            showError: true,
                            rule: 'required'
                        })
                    } else {
                        this.validateErrors.removeAll(this.PAGE,'model.getVoucherRule.voucherLoaders')
                    }
                    this.validateErrors.removeAll(this.PAGE,'model.getTicketRule.voucherLoaders')
                }
            },
            integerHandle(e) {
                if (e.target.value === '') {
                    e.target.value = ''
                }
            },
            limitCheck (type, value) {
                this.doBuyLimitShow();
            },
            doBuyLimitShow () {
                let model = this.model;
                if (!model) return;
                this.buyLimitShow = false;
                let phoneShow, idShow;
                if ((model.contractInfoType === 2 && model.contractInfoRule && model.contractInfoRule.mobile) || (model.visitorInfoRule && model.visitorInfoRule.mobile && model.visitorInfoType !== 1)) {
                    // console.log('model.phoneLimitCount', model.phoneLimitCount)
                    if (model.phoneLimitCount > 0) this.buyLimitShow = true;
                    phoneShow = true;
                }
                if (model.visitorInfoType !== 1 && model.visitorInfoRule && model.visitorInfoRule.credentials) {
                    // console.log('model.id', model.idLimitCount)
                    idShow = true;
                    if (model.idLimitCount > 0)  this.buyLimitShow = true;
                }
                // if (!this.buyLimitShow && (phoneShow || idShow)) {
                //     this.model.limitDayType = 0;
                // }
            },
            updateModel () {
                if (this.model.voucherTimes.length > 0) {
                    this.voucherTimes = [];
                    for (let i = 0; i < this.model.voucherTimes.length; i++) {
                        this.voucherTimes.push({
                            voucherStartTimeHour: Math.floor(this.model.voucherTimes[i].voucherStartTime/60),
                            voucherStartTimeMinute: this.model.voucherTimes[i].voucherStartTime%60,
                            voucherEndTimeHour: Math.floor(this.model.voucherTimes[i].voucherEndTime/60),
                            voucherEndTimeMinute: this.model.voucherTimes[i].voucherEndTime%60
                        })
                        if (!this.model.voucherTimes[i].voucherOrGetInTimeSupplement) {
                            this.model.voucherTimes[i].voucherOrGetInTimeSupplement = ''
                        }
                    }
                }
                if (this.model.mtDealId) {
                    this.onlineBefore = true
                } else {
                    this.onlineBefore = false
                }
                this.doBuyLimitShow();
            }
        },
        directives: {
            'textarea-check': function (el) {
                const text = el.getElementsByTagName('textarea')[0].value
                const errorNotice = el.parentNode.getElementsByClassName('is-danger')[0]
                if (errorNotice) {
                    errorNotice.style.display = 'none';
                    for (let i = 0; i< textareaForbiddenWords.length; i++) {
                        if (text.indexOf(textareaForbiddenWords[i]) !== -1) {
                            errorNotice.style.display = 'block'
                            errorNotice.innerText = '请勿在此处填写'+textareaForbiddenWords[i]+'信息'
                        }
                    }
                }
            }
        },
        watch: {
            model: function () {
                this.updateModel();
            }
        },
        mounted () {
            this.$watch(function () {
                let model = this.model;
                if (!model || !Object.keys(model).length) return false;
                if ((model.contractInfoType === 2 && model.contractInfoRule.mobile) || (model.visitorInfoRule.mobile && model.visitorInfoType !== 1)) {
                    console.log('model.phoneLimitCount', model.phoneLimitCount)
                    if (model.phoneLimitCount > 0) return true;
                }
                if (model.visitorInfoType !== 1 && model.visitorInfoRule.credentials) {
                    console.log('model.id', model.idLimitCount)
                    if (model.idLimitCount > 0) return true;
                }
                return false;
            }, function (val) {
                this.buyLimitShow = val;
            }, {
                immediate: true
            });
        }
    }
</script>


// WEBPACK FOOTER //
// Instruction.vue?b710ff1c